/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-tick-circle': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm4.666 8.432a.75.75 0 0 0-1.06.035l-5.011 5.35-1.677-1.815-.08-.075a.75.75 0 0 0-1.02 1.094l2.223 2.405.078.073a.75.75 0 0 0 1.02-.07L16.7 9.493l.07-.086a.75.75 0 0 0-.104-.974z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
